import React from 'react'
import { Box, Chip, Stack, Typography } from '@mui/material'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import RadioButtonUncheckedRoundedIcon from '@mui/icons-material/RadioButtonUncheckedRounded'

const AppraisalModalHeader = ({ title, subtitle, steps }) => {
  return (
    <Box
      sx={{
        p: { xs: 2.25, md: 3 },
        mb: 2.5,
        background:
          'linear-gradient(135deg, #242F40 0%, #2c3e50 65%, #239AA4 150%)',
        color: 'white',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Poppins, sans-serif',
          fontWeight: 700,
          fontSize: { xs: '1.25rem', md: '1.4rem' },
          color: 'white',
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="body2"
          sx={{ opacity: 0.8, mt: 0.5, color: 'white' }}
        >
          {subtitle}
        </Typography>
      )}

      {!!steps?.length && (
        <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 2 }}>
          {steps.map((step) => (
            <Chip
              key={step.label}
              icon={
                step.status === 'done' ? (
                  <CheckCircleRoundedIcon
                    sx={{ color: '#4DBBC4 !important' }}
                  />
                ) : (
                  <RadioButtonUncheckedRoundedIcon
                    sx={{ color: 'rgba(255,255,255,0.6) !important' }}
                  />
                )
              }
              label={step.label}
              sx={{
                height: 28,
                fontWeight: 700,
                fontSize: 12,
                color:
                  step.status === 'upcoming'
                    ? 'rgba(255,255,255,0.6)'
                    : '#FFFFFF',
                bgcolor:
                  step.status === 'current'
                    ? 'rgba(255,255,255,0.20)'
                    : 'rgba(255,255,255,0.08)',
              }}
            />
          ))}
        </Stack>
      )}
    </Box>
  )
}

export default AppraisalModalHeader
